var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.6,
    stroke: "#6FCF97",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51077 8.26252L5.51059 8.26235L3.7461 6.59559L3.74607 6.59557C3.61888 6.47534 3.61772 6.27757 3.74414 6.15617M5.51077 8.26252L8.92496 4.55124C8.83365 4.47559 8.69536 4.48481 8.6164 4.57157L8.5426 4.50409L8.54255 4.50414C8.54251 4.50418 8.54248 4.50422 8.54244 4.50426L5.71653 7.59475L4.19156 6.15431L4.19139 6.15416C4.06684 6.03704 3.86773 6.03727 3.74414 6.15617M5.51077 8.26252C5.57068 8.31882 5.65066 8.35 5.73321 8.35L5.73372 8.35C5.73592 8.35 5.74086 8.35001 5.74652 8.34967M5.51077 8.26252L5.74652 8.34967M3.74414 6.15617C3.74413 6.15618 3.74411 6.1562 3.7441 6.15621L3.81344 6.22827L3.74419 6.15612C3.74418 6.15614 3.74416 6.15615 3.74414 6.15617ZM5.89819 8.17833L8.94614 4.84524L5.57926 8.18965C5.62028 8.22821 5.67564 8.25 5.73321 8.25H5.73322C5.73608 8.25 5.73873 8.25 5.74137 8.24979M5.89819 8.17833C5.85849 8.22192 5.80181 8.2477 5.74137 8.24979M5.89819 8.17833L5.97199 8.24582L5.97204 8.24576C5.91401 8.30943 5.83235 8.34625 5.74652 8.34967M5.89819 8.17833L5.97212 8.24567L9.0199 4.91275C9.01991 4.91274 9.01992 4.91273 9.01993 4.91272L5.74652 8.34967M5.74137 8.24979L5.74484 8.34973C5.7454 8.34971 5.74596 8.34969 5.74652 8.34967M5.74137 8.24979L5.74927 8.34948C5.74834 8.34955 5.74742 8.34961 5.74652 8.34967",
    fill: "#6FCF97",
    stroke: "#6FCF97",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/pass_icon.36652c69.svg";
export { ForwardRef as ReactComponent };